// Модуль для инициализации Swiper слайдеров
// LEGACY: Все слайдеры теперь инициализируются автоматически через swiper-auto.js
// с использованием data-атрибутов в разметке

export default function initSliders() {
  // Все слайдеры (testimonials, partners, news и т.д.) теперь инициализируются
  // через swiper-auto.js при наличии атрибута data-swiper.
  // Этот модуль оставлен для обратной совместимости, но больше не выполняет инициализацию.
}
